import { FC, useContext, useEffect, useState } from "react";
import React from "react";
import { BiChevronDown } from "react-icons/bi";
import { EmailSelectedContext } from "../../../context/EmailSelectedContext";
import Modal from "../Modal";
import {
  DropdownItem,
  DropdownItemColors,
  DropdownOptions,
  DropdownsContainer,
  DropdownsIcon,
  DropdownsInput,
  DropdownsInputContainer,
  DropdownsWrapper,
  Hr,
  Pre,
  TitleModal,
} from "./styled";

interface DropdownProps {
  options: { email: string; color: string; checked?: boolean }[];
  onChange: (value: string) => void;
  value: string;
}

export const Select: FC<DropdownProps> = ({ options, onChange, value }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [showMenuMobile, setShowMenuMobile] = useState(false);
  const [selectedValue, setSelectedValue] = useState(value);
  const [renderedSelect, setRenderedSelect] = useState(false);
  const [currentColor, setCurrentColor] = useState(options?.[0].color);
  const { setSelectedEmail } = useContext(EmailSelectedContext);

  useEffect(() => {
    if (!renderedSelect) {
      onItemClick(options[0]);
      setRenderedSelect(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleInputClick = () => {
    if (window.innerWidth < 768) {
      setShowMenuMobile((prevShowMenuMobile) => !prevShowMenuMobile);
    } else {
      setShowMenu((prevShowMenu) => !prevShowMenu);
    }
  };

  const handleSelectedValueClick = () => {
    setShowMenu(false);
  };

  const RenderDropdownInputs = () => {
    return (
      <DropdownsInputContainer>
        <DropdownsInput display="block" color={currentColor}>
          <div
            className="dropdown-selected-value"
            onClick={handleSelectedValueClick}
          >
            <Pre>{selectedValue}</Pre>
          </div>
        </DropdownsInput>
        {options.length > 1 && (
          <div className="dropdown-tools">
          <DropdownsIcon onClick={handleInputClick}>
            <BiChevronDown size={20} fill="#111" />
          </DropdownsIcon>
        </div>
        )}
      </DropdownsInputContainer>
    );
  };

  const onItemClick = (option: { email: string; color: string }) => {
    setSelectedEmail(option);
    setCurrentColor(option.color);
    setSelectedValue(option.email);
    onChange(option.email);
    setShowMenu(false);
    setShowMenuMobile(false);
  };

  const ModalMobile = () => {
    return (
      <Modal isOpen={showMenuMobile}>
        <TitleModal>Selecione o Signatário</TitleModal>
        <DropdownOptions>
          <Hr />
          {options?.map((option) => (
            <React.Fragment key={option.email}>
              <DropdownsWrapper>
                <DropdownItemColors color={option.color}></DropdownItemColors>
                <DropdownItem onClick={() => onItemClick(option)}>
                  {option.email}
                </DropdownItem>
              </DropdownsWrapper>
              <Hr />
            </React.Fragment>
          ))}
        </DropdownOptions>
      </Modal>
    );
  };

  return (
    <DropdownsContainer>
      <RenderDropdownInputs />
      {showMenuMobile && ModalMobile()}
      {showMenu && (
        <DropdownOptions>
          {options?.map((option) => (
            <DropdownsWrapper key={option.email}>
              <DropdownItemColors color={option.color}></DropdownItemColors>
              <DropdownItem onClick={() => onItemClick(option)}>
                {option.email}
              </DropdownItem>
            </DropdownsWrapper>
          ))}
        </DropdownOptions>
      )}
    </DropdownsContainer>
  );
};
